<template>
	<div class="component-frame-page">
		<SmartDisplayC
			v-if="isMobile"
			:compId="getModuleId(activeModule)"
			mode="mob-full"
			v-bind="getModuleProps(activeModule)"
		/>
		<div v-else class="pc-module-main">
			<ContentPad>
				<SmartDisplayC :compId="getModuleId(activeModule)" mode="full" v-bind="getModuleProps(activeModule)" />
			</ContentPad>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ComponentFrame'
};
</script>
<script setup>
import SmartDisplayC from '@rebuild/components/SmartDisplayC.vue';
import ContentPad from '@rebuild/materials/shared/common/ContentPad.vue';
import { useStore } from '@/utils/vue-api';
import { ref, getCurrentInstance, computed } from 'vue';
import { useModuleAttrs } from '@rebuild/hooks/useModuleAttrs';

const vm = getCurrentInstance();
const store = useStore();
const isMobile = computed(() => store.getters.isMobileMode);

const activeModule = ref();
const { getModuleId, getModuleProps } = useModuleAttrs();
const initModuleRender = () => {
	const moduleId = vm.proxy.$route.params?.moduleId;
	const allModules = store.getters.getPageAllModules;

	let module;
	if (moduleId) {
		module = allModules.find(item => item.moduleId === moduleId);
		activeModule.value = module;
	}
	if (!module) {
		activeModule.value = { moduleId: moduleId };
	}
};
initModuleRender();
</script>

<style lang="less" scoped>
.pc-module-main {
	padding-top: 32px;
	padding-bottom: 67px;
}
</style>
